import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, X } from "lucide-react";
import { api } from "@/lib/api";

export default function TeamTestsNotice({ markSeenOnView = false }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    api("/laser/notices").then((r) => { setD(r); if (markSeenOnView && r.count) api("/laser/notices/seen", { method: "POST" }).catch(() => {}); }).catch(() => {});
  }, [markSeenOnView]);
  if (!d || !d.count) return null;
  const dismiss = () => { setD(null); api("/laser/notices/seen", { method: "POST" }).catch(() => {}); };
  const top = d.items[0];
  return (
    <div data-testid="team-tests-notice" className="relative flex items-start gap-3 rounded-[14px] border p-4" style={{ borderColor: "rgba(76,204,6,0.45)", background: "rgba(76,204,6,0.07)" }}>
      <Users size={20} color="#4CCC06" className="mt-0.5 shrink-0" />
      <div className="min-w-0 flex-1">
        <p data-testid="team-tests-notice-title" className="text-sm font-bold text-white">{d.count} new test piece{d.count === 1 ? "" : "s"} from the ALR team{d.on_my_machine ? ` — ${d.on_my_machine} on a machine like yours` : ""}</p>
        {top && <p className="mt-0.5 text-xs text-neutral-300">Latest: {top.machine_name} · {top.substrate_detail} / {top.contaminant}{top.my_machine ? " (your machine)" : ""}</p>}
        <p className="mt-1 text-xs text-neutral-400">{d.my_tests ? "Keep it going — log your next test piece so everyone dials in faster." : "Add yours too — every test makes the Cleaning Agent more reliable for all of us."}</p>
        <div className="mt-2 flex gap-2">
          {!markSeenOnView && <Link to="/laser-machines" onClick={dismiss} data-testid="team-tests-notice-view" className="rounded-lg px-3 py-1.5 text-xs font-extrabold text-black" style={{ background: "#4CCC06" }}>See tests & log yours</Link>}
        </div>
      </div>
      <button onClick={dismiss} aria-label="Dismiss" data-testid="team-tests-notice-dismiss" className="rounded-full p-1 text-neutral-400 hover:text-white"><X size={15} /></button>
    </div>
  );
}
